define(function(require, exports, module) {
    'use strict';

    function getAPI(namespace) {
        if (window.Communication && window.Communication.API && window.Communication.API[namespace]) {
            return window.Communication.API[namespace];
        }
    }

    function call() {
        var args = [].slice.call(arguments);
        var namespace = args[0];
        var method = args[1];
        var api = getAPI(namespace);

        if (!api) {
            return null;
        }

        if (api[method]) {
            return api[method].apply(api, args.slice(2));
        }

        console.warn('Communication.API.' + namespace + '.' + method + ' does not exist');
    }

    module.exports = function(namespace) {
        return function() {
            var args = [].slice.call(arguments);
            return call.apply(null, [namespace].concat(args));
        };
    };
});
